import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faInfoCircle,
  faWineBottle,
  faTimes,
  faBan
} from '@fortawesome/free-solid-svg-icons';
import { getAllDressings } from '../../db';
import './DressingSelector.css';

const DressingSelector = ({ selectedDressings, onUpdateDressings, style, includedDressings = [] }) => {
  // Get dressing options from the database
  const dressingOptions = getAllDressings();
  
  // Track first render
  
  
  // We're no longer using this effect since SandwichBuilder now handles all default selections
  // This component is now fully controlled by its parent
  
  const handleDressingToggle = (dressingId) => {
    // If already selected, remove it regardless of whether it's a style default
    if (selectedDressings.includes(dressingId)) {
      // Just remove this dressing without any extra conditions
      const updatedDressings = selectedDressings.filter(id => id !== dressingId);
      onUpdateDressings(updatedDressings); // It's OK if this is empty
    } else {
      // Otherwise add it
      const updatedDressings = [...selectedDressings, dressingId];
      onUpdateDressings(updatedDressings);
    }
  };
  
  const isDressingSelected = (dressingId) => {
    return selectedDressings.includes(dressingId);
  };

  
  
  return (
    <div className="dressing-selector-container">
      <div className="dressing-grid">
        {dressingOptions.map(dressing => (
          <div
            key={dressing.id}
            className={`dressing-card ${isDressingSelected(dressing.id) ? 'selected' : ''}`}
            onClick={() => handleDressingToggle(dressing.id)}
          >
            <FontAwesomeIcon 
              icon={dressing.id === 'no-dressing' ? faBan : faWineBottle} 
              className="dressing-icon" 
            />
            <span className="dressing-name">{dressing.name}</span>
            {isDressingSelected(dressing.id) && (
              <FontAwesomeIcon icon={faTimes} className="remove-dressing" />
            )}
          </div>
        ))}
      </div>
      
      {/* Summary of selections */}
      {selectedDressings.length > 0 && (
        <div className="dressing-summary">
          <h4>Selected Dressings:</h4>
          <div className="selected-dressings-list">
            {selectedDressings.map(dressingId => {
              const dressing = dressingOptions.find(d => d.id === dressingId);
              return (
                <div 
                  key={dressingId} 
                  className="selected-dressing-pill"
                >
                  <span>{dressing?.name}</span>
                  <button 
                    className="remove-dressing-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDressingToggle(dressingId);
                    }}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      )}
      
      <div className="dressing-info-note">
        <h4>
          <FontAwesomeIcon icon={faInfoCircle} />
          About Dressings
        </h4>
        <p>
          The first two dressings are included at no additional cost. Each additional dressing is $1.25. 
          {includedDressings && includedDressings.length > 0 && ' Some dressings are included with your selected style.'}
        </p>
      </div>
    </div>
  );
};

export default DressingSelector;